import { render } from "./PolicyTable.vue?vue&type=template&id=7aafea38&scoped=true"
import script from "./PolicyTable.vue?vue&type=script&lang=js"
export * from "./PolicyTable.vue?vue&type=script&lang=js"

import "./PolicyTable.vue?vue&type=style&index=0&id=7aafea38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aafea38"]])

export default __exports__